import { createContext } from "react"
import type { LearnerAuthStatus, StudentInfo, StudentLoginPayload } from "./types"

export interface LearnerAuthContextValue {
  status: LearnerAuthStatus
  student: StudentInfo | null
  isAuthenticated: boolean
  isBooting: boolean
  login: (payload: StudentLoginPayload) => Promise<StudentInfo>
  logout: (options?: { redirect?: boolean }) => void
  refreshProfile: () => Promise<StudentInfo>
}

export const LearnerAuthContext = createContext<LearnerAuthContextValue | null>(
  null
)
